import React from "react";
import { Link } from "react-router-dom";

function Sidebar() {
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li className="nav-item">
          <Link className="nav-link" to="/">
            <i className="mdi mdi-file-document-box menu-icon"></i>
            <span className="menu-title">Lessons</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/bills">
            <i className="mdi mdi-circle-edit-outline menu-icon"></i>
            <span className="menu-title">Bills</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/activity">
            <i className="mdi mdi-circle-edit-outline menu-icon"></i>
            <span className="menu-title">Planning</span>
          </Link>
        </li>
        <li className="nav-item border-top"></li>
      </ul>
    </nav>
  );
}

export { Sidebar };
